import { Navigate, useLocation } from 'react-router-dom'

/** AI Agent's voice pages moved to Agents → Voice; old links land there. */
export default function AIAgentIndex() {
  const { search } = useLocation()
  return <Navigate to={`/agents/voice${search}`} replace />
}
